<template>
  <div class="card mx-auto">
    <div class="card-body">
      <h5 class="card-title">
        {{ titulo }}
      </h5>
      <p class="card-text">
        {{ subTitulo }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: { type: [String, Number], default: 0 },
    subTitulo: { type: String, required: true },
  },
};
</script>
